export default "<div class=\"page-header\">\n    <h1>{{page.pageInfo.title}}</h1>\n</div>\n<div ta-bind ng-model=\"page.pageInfo.content\"></div>";